<template>
  <div class="block">
    <el-carousel indicator-position="outside" height="860px">
      <el-carousel-item v-for="item in imgList" :key="item.id" @change="changeItem(item)">
        <img :src="item.src" alt="" class="image">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<style scoped>
.block{
  width: 1920px;
}
.image {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  /*锁定图片的长宽比 */
}
</style>
<script>
export default {
  name: 'img',
  data() {
    return {
      imgList: [
        {
          src:"http://116.62.38.250//image/sy/lben.jpg"
        }
        // {
        //   src: "/Users/liuwei/yk/img",
        // }
        // , {
        //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        // },
        // {
        //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        // },
      ]
    }
  },
  methods: {
    //切换轮播图
    changeItem() {

    }
  }


}
</script>



// WEBPACK FOOTER //
// src/components/en/image/image.vue